<form name="vm.form" #mainForm="ngForm" class="c-form" autocomplete="off">
	<div class="o-grid o-grid--center-h">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
			<section class="c-section c-section--first c-section--last c-section--open c-section--static" [ngClass]="{'c-section--error': vm.submitted && vm.formInvalid}">
				<div class="c-section__header" *ngIf="vm.isAvailable">
					<div id="benuLogoContainer" *ngIf="vm.thirdPartyRenewal === 'benu'">
						<img id="benuLogo1"
							src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png"
							style="max-width: 20%" class="u-hidden@md-and-up"> <img
							id="benuLogo2"
							src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png"
							style="position: absolute; max-width: 20%"
							class="u-hidden@up-to-md">
					</div>
					<h1 class="c-section__title c-section__title--sm c-text c-text--center">
						{{ 'Booking.Prescription.Title' | translate }}
					</h1>
				</div>
				<div class="c-section__content" [ngSwitch]="vm.isAvailable">
					<div class="c-card" *ngSwitchCase="false">
						<div class="c-content c-content--xxl">
							<p class="c-text c-text--center u-osb-lg">
								{{ 'Booking.Prescription.Service_Unavailable' | translate }}
							</p>
							<div class="o-grid o-grid--center-h u-osb-lg">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
									<button id="sendReminderButton" type="button"
										class="c-button c-button--s2 c-button--fit"
										(click)="vm.sendReminder()"
										[disabled]="vm.reminderSent || vm.isProcessing">
										{{ 'Booking.Prescription.Send_Reminder' | translate }}
									</button>
								</div>
							</div>
							<div class="o-grid o-grid--center-h" *ngIf="!vm.isRefunded">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
									<button id="redirectHomeButton" type="button"
										class="c-button c-button--link c-button--fit"
										(click)="vm.handleRedirectHome()">
										{{ 'Common.To_Main' | translate }}
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="c-card" [ngClass]="{'c-card--error': vm.submitted && vm.formInvalid}" *ngSwitchCase="true">
						<div class="c-content c-content--xxl">
							<p class="c-text c-text--sm c-text--center u-osb-xl" *ngIf="!vm.isPreVisit">
								{{'Booking.Prescription.Disclaimer_Default' | translate }}
							</p>
							<p class="c-text c-text--sm c-text--center u-osb-xl" *ngIf="vm.isPreVisit">
								{{'Booking.Prescription.Disclaimer_Default_Pre_Visit' | translate }}
							</p>
	
							<div class="u-osb-xl@md-and-up u-osb-md@up-to-md" *ngIf="vm.ehifPrescription">
								<p class="c-form__label c-text c-text--center">
									{{'Booking.Prescription.Number' | translate}}: <b>{{vm.ehifPrescription.prescriptionNumber}}</b>
								</p>
								<p class="c-form__label c-text c-text--center">
									{{'Booking.Prescription.Prescription_Active_Ingredient' | translate}}: <b>{{vm.ehifPrescription.atcName}}</b>
								</p>
							</div>
							<div class="u-osb-xl@md-and-up u-osb-md@up-to-md" *ngIf="!vm.ehifPrescription">
								<p class="c-text c-text--center c-text--bold u-ost-md" *ngIf="vm.prescriptionNumber">
									{{ 'Booking.Prescription.Number' | translate }}: {{ vm.getExistingPrescriptionDetails() }}
								</p>
								<div class="o-grid o-grid--wrap o-grid--center-h" *ngIf="!vm.prescriptionNumber">
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-40@md-and-up u-no-p">
										<div class="c-form__group u-no-m@md-and-up" [ngClass]="{'c-form__group--error': (vm.submitted && vm.invalidDrug)}">
											<label for="ingredient" class="c-form__label">
												{{ 'Booking.Prescription.Insert_Ingredient' | translate }}
											</label>
											<input-autocomplete 
												id="drugIngredient" 
												name="drugIngredient"
												[(model)]="vm.formData.drugIngredient"
												[searchFn]="vm.handleIngredientSearch"
												[isRequired]="!vm.formData.drug" 
												[minLength]="1">
											</input-autocomplete>
										</div>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--bottom u-hidden@up-to-md">
										<p class="c-text" style="margin-bottom: 12px;" [ngClass]="{'c-text--s3': (vm.submitted && vm.invalidDrug)}">
											{{ 'Common.Or' | translate | lowerCase }}
										</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-40@md-and-up u-no-p">
										<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': (vm.submitted && vm.invalidDrug)}">
											<label for="ingredient" class="c-form__label">
												{{ 'Booking.Prescription.Insert_Drug' | translate }}
											</label>
											<input-autocomplete 
												id="drug" 
												name="drug"
												[(model)]="vm.formData.drug"
												[searchFn]="vm.handleDrugSearch" 
												[opts]="vm.drugOpts"
												[isRequired]="!vm.formData.drugIngredient" 
												[minLength]="1">
											</input-autocomplete>
										</div>
									</div>
								</div>
								<p class="c-text c-text--center c-text--s3 u-ost-md" *ngIf="(vm.submitted && vm.invalidDrug)">
									{{ 'Booking.Prescription.Error_Drug_Or_Ingredient' | translate }}
								</p>
								<p class="c-text c-text--center c-text--s3 u-ost-md"
									*ngIf="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)">
									{{ vm.formData?.drug?.disclaimer || vm.formData?.drugIngredient?.disclaimer }}
								</p>
								<p class="c-text c-text--center c-text--bold u-ost-md"
									*ngIf="vm.formData?.drug?.disclaimerType==='ANTIFUNGAL' || vm.formData?.drugIngredient?.disclaimerType==='ANTIFUNGAL'">
									{{ vm.formData?.drug?.disclaimer || vm.formData?.drugIngredient?.disclaimer }}
								</p>
							</div>
							<div class="o-grid o-grid--center-h u-ost-md@up-to-md"
								*ngIf="vm.formData?.drugIngredient?.disclaimerConfirm || vm.formData?.drug?.disclaimerConfirm">
								<div
									class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
									<div class="c-form__group" [ngClass]="{'c-form__group--error': (vm.submitted && !vm.formData.disclaimerAccepted)}">
										<label class="c-checkbox">
											<input type="checkbox" name="disclaimer" [(ngModel)]="vm.formData.disclaimerAccepted" #disclaimerAccepted="ngModel" required>
											<span>
												{{ 'Booking.Prescription.Disclaimer_Accept' | translate }} 
												<a href="{{ vm.formData?.drugIngredient?.disclaimerUrl || vm.formData?.drug?.disclaimerUrl }}" 
													target="_blank" class="c-text c-text--bold">
													{{ 'Common.Here' | translate | upperCase }}
												</a>
											</span>
										</label>
									</div>
								</div>
							</div>
							<div class="o-grid o-grid--center-h u-ost-md@up-to-md">
								<div
									class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
									<div class="c-form__group"
										[ngClass]="{'c-form__group--error': (vm.submitted && !vm.formData.dosageFrequency)}">
										<label for="frequency" class="c-form__label u-osb-xs"
											[ngClass]="{'c-form__label--disabled': (vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)}">
											{{ 'Booking.Prescription.Frequency_Label' | translate }}
										</label>
										<p class="c-text c-text--sm u-osb-md"
											[ngClass]="{'c-text--gray': (vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)}">
											({{ 'Booking.Prescription.Frequency_Label_Info_1' | translate | lowerCase }}: 
											<span class="c-text c-text--italic">{{ 'Booking.Prescription.Frequency_Label_Info_2' | translate }}</span>
											{{ 'Common.Or' | translate | lowerCase }}
											<span class="c-text c-text--italic">{{ 'Booking.Prescription.Frequency_Label_Info_3' | translate }}</span>)
										</p>
										<input type="text" 
											id="frequency" 
											name="frequency"
											class="c-form__input" maxlength="100"
											[(ngModel)]="vm.formData.dosageFrequency"
											#dosageFrequency="ngModel"
											[disabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"
											required />
									</div>
								</div>
							</div>
							<div class="c-form__group"
								[ngClass]="{'c-form__group--error': vm.submitted && !vm.formData.prescriptionUsage}">
								<input-tabs id="usage" name="usage"
									[(model)]="vm.formData.prescriptionUsage" [isRequired]="true"
									[tabs]="vm.usages" [label]="vm.labels.usage"
									[isRequired]="true"
									[isDisabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></input-tabs>
							</div>
							<div class="c-form__group"
								[ngClass]="{'c-form__group--error': vm.submitted && !vm.formData.prescriptionEffect}">
								<input-tabs id="effect" name="effect"
									[(model)]="vm.formData.prescriptionEffect" [isRequired]="true"
									[tabs]="vm.effects" [label]="vm.labels.effect"
									[isRequired]="true"
									[isDisabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></input-tabs>
							</div>
							<div class="c-form__group"
								[ngClass]="{'c-form__group--error': vm.submitted && !vm.formData.prescriptionExpiry}">
								<input-tabs id="expiry" name="expiry"
									[(model)]="vm.formData.prescriptionExpiry" [isRequired]="true"
									[tabs]="vm.expiries" [label]="vm.labels.expiry"
									[isRequired]="true"
									[isDisabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></input-tabs>
							</div>
							<div class="c-form__group"
								[ngClass]="{'c-form__group--error': vm.submitted && !vm.formData.prescriptionRequestReason}">
								<input-tabs id="reason" name="reason"
									[(model)]="vm.formData.prescriptionRequestReason"
									[isRequired]="true" [tabs]="vm.reasons"
									[label]="vm.labels.reason" [isRequired]="true"
									[isDisabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></input-tabs>
							</div>
							<div class="o-grid o-grid--center-h u-ost-md@up-to-md">
								<div
									class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
									<div class="c-form__group u-no-m"
										[ngClass]="{'c-form__group--error': vm.submitted && problemDescription.invalid}">
										<label for="problemDescription" class="c-form__label"
											[ngClass]="{'c-form__label--disabled': (vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)}">{{
											'Booking.Prescription.Problem_Description' | translate }}</label>
										<textarea rows="5" id="problemDescription"
											name="problemDescription" class="c-form__input"
											[(ngModel)]="vm.formData.problemDescription"
											required="true" 
											#problemDescription="ngModel"
											maxlength="{{vm.descriptionMaxLength}}"
											[disabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></textarea>
										<p class="c-text c-text--sm c-text--right c-text--gray"
											[ngClass]="{ 'c-text--s3': vm.submitted && problemDescription?.errors?.maxlength }">{{
											problemDescription?.value?.length || 0 }} / {{
											vm.descriptionMaxLength }}</p>
									</div>
								</div>
							</div>
							<div class="o-grid o-grid--center-h u-ost-md@up-to-md">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
									<div class="c-form__group"
										[ngClass]="{'u-no-m': vm.hasSideEffects !== 'YES', 'c-form__group--error': vm.submitted && !vm.hasSideEffects}">
										<input-tabs id="sideEffectsToggle" name="sideEffectsToggle"
											[(model)]="vm.hasSideEffects" [isRequired]="true"
											[tabs]="vm.sideEffectsToggle"
											[label]="vm.labels.sideEffectsToggle" [isRequired]="true"
											[isDisabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></input-tabs>
									</div>
									<div class="c-form__group u-no-m" *ngIf="vm.hasSideEffects === 'YES'"
										[ngClass]="{'c-form__group--error': vm.submitted && sideEffects.invalid}">
										<label for="sideEffects" class="c-form__label"
											[ngClass]="{'c-form__label--disabled': (vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)}">
											{{ 'Booking.Prescription.Side_Effects' | translate }}
										</label>
										<input
											type="text" 
											id="sideEffects" 
											name="sideEffects"
											class="c-form__input" 
											maxlength="300"
											[(ngModel)]="vm.formData.sideEffects"
											#sideEffects="ngModel"
											[disabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"
											required />
									</div>
								</div>
							</div>
							<div class="o-grid o-grid--center-h u-ost-md" *ngIf="!vm.isPreVisit">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && !vm.isProlongedRequestAllowed}">
										<input-tabs 
											id="prolongedRequestAllowedToggle"
											name="prolongedRequestAllowedToggle"
											[(model)]="vm.isProlongedRequestAllowed" 
											[isRequired]="true"
											[tabs]="vm.prolongedRequestAllowedToggle"
											[label]="vm.labels.prolongedRequestAllowedToggle"
											[isRequired]="true"
											[isDisabled]="(vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)"></input-tabs>
									</div>
								</div>
							</div>
							
						</div>
					</div>
					<loader-overlay *ngIf="vm.isProcessing"></loader-overlay>
				</div>
			</section>
			<div class="o-grid" *ngIf="vm.isAvailable">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p@md-and-up">
					<button id="extendPrescriptionButton" 
						type="button" 
						class="c-button c-button--s2 c-button--fit c-button--lg u-ost-md u-osb-md" 
						(click)="vm.handleFormSubmit(mainForm)" 
						[disabled]="vm.isProcessing || (vm.formData?.drugIngredient?.isAvailable === false) || (vm.formData?.drug?.isAvailable === false)">
						{{ 'Booking.Prescription.Extend' | translate }}
					</button>
				</div>
			</div>
		</div>
	</div>
</form>